registerComponent("pages/videos-internal", function (component) {
/**
 * O corpo recebe o elemento raiz do componente em `component`; o build o
 * envolve em registerComponent(). Os antigos `params` viraram @props no Blade.
 *
 * ⚠️ O embrulho `document.addEventListener('DOMContentLoaded', …)` de 2020
 * SAIU — mesmo motivo do `pages/videos`: o `registerComponent` inicializa
 * DURANTE o despacho do `DOMContentLoaded`, e um listener acrescentado no meio
 * do despacho não é chamado. O abre/fecha do submenu de temas estava morto
 * desde a Fase 2, sem erro no console.
 *
 * O trecho do `#limit` (o seletor de itens por página) já estava FORA do
 * embrulho e continuou rodando o tempo todo — é o único pedaço deste arquivo
 * que a Fase 2 não quebrou. Ele fica como está: lê e reescreve
 * `location.search`, e o `in_array` do Blade é quem valida o valor de verdade.
 */

const showSubMenu = document.getElementById('showSubMenu');
const btnClose = document.getElementById('btnClose');
const subMenu = document.getElementById('subMenu');
const bgBeige = component.querySelector('.bg-beige');
const filterButtons = component.querySelector('.filter-buttons');

showSubMenu.addEventListener('click', function () {
    const isActive = subMenu.classList.contains('active');
    subMenu.classList.toggle('active', !isActive);
    showSubMenu.classList.toggle('active', !isActive);

    if (isActive) {
        bgBeige.style.backgroundColor = '';
        btnClose.style.display = 'none';
        filterButtons.style.display = 'block';
    } else {
        bgBeige.style.backgroundColor = '#F3F0EA';
        btnClose.style.display = 'block';
        filterButtons.style.display = 'none';
    }
});

btnClose.addEventListener('click', function () {
    subMenu.classList.remove('active');
    showSubMenu.classList.remove('active');
    bgBeige.style.backgroundColor = '';
    btnClose.style.display = 'none';
    filterButtons.style.display = 'block';
});

const limitSelect = document.getElementById('limit');

limitSelect.addEventListener('change', function (event) {
    event.preventDefault();

    const params = new URLSearchParams(window.location.search);
    params.set('limit', this.value);

    window.location.search = params;
});

const limits = [15, 30, 60, 120];
let limit = new URLSearchParams(window.location.search).get('limit');

if (limit) {
    limit = parseInt(limit, 10);
    limitSelect.value = limits.indexOf(limit) !== -1 ? limit : 15;
}

});
